// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 775) return "static/chunks/775-ae655d5b3cc9b67d.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"d3595e2d4a1febd7","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"011f7724a7d955c7","367":"223db5b5b633c159","639":"e7b660adfa99260e","748":"c479af15a805e82f"}[chunkId] + ".js";
};